// extracted by mini-css-extract-plugin
module.exports = {"detailTab":"detailTab___3QYo4"};